import { motion } from "framer-motion";
import { Flame, ShieldCheck, Droplets } from "lucide-react";

const CARDS = [
  {
    tag: "Step 1",
    title: "Spray it on",
    description:
      "Attach NOXWAY to a standard garden hose and coat rooflines, eaves, decks and surrounding brush before wildfire exposure.",
    icon: Droplets,
  },
  {
    tag: "Step 2",
    title: "Evacuate with confidence",
    description:
      "The gel barrier holds 24–48 hours, insulating surfaces against radiant heat and helping extinguish ember strikes on contact.",
    icon: Flame,
  },
  {
    tag: "Step 3",
    title: "Rinse it off",
    description:
      "After the event, the non-toxic, biodegradable gel washes away with clean water. No staining, no residue.",
    icon: ShieldCheck,
  },
];

export default function Features() {
  return (
    <section id="how" className="py-20 lg:py-28 bg-white" data-testid="features-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-14"
        >
          <div className="font-tech text-[11px] tracking-[0.3em] text-[#f97316] uppercase mb-4" data-testid="features-kicker">
            How it works
          </div>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-[#17150f]" data-testid="features-headline">
            Give your home a fighting chance.
          </h2>
          <p className="mt-4 text-base text-stone-600 leading-relaxed" data-testid="features-description">
            When minutes separate safety from loss, NOXWAY adds a practical layer of defense for your home,
            landscape and critical assets — alongside your official fire-safety plan.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CARDS.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.tag}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="rounded-xl border border-stone-200 bg-[#faf9f7] p-8"
                data-testid={`feature-card-${i}`}
              >
                <span className="w-11 h-11 rounded-lg bg-[#f97316]/10 flex items-center justify-center mb-6">
                  <Icon size={20} className="text-[#f97316]" strokeWidth={2} />
                </span>
                <div className="font-tech text-[10px] tracking-[0.25em] uppercase text-stone-400 mb-2">{card.tag}</div>
                <h3 className="font-display font-semibold text-xl text-[#17150f] mb-3">{card.title}</h3>
                <p className="text-sm text-stone-600 leading-relaxed">{card.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
